import React from 'react';

import TrainingDefinitionsList from './List';
import TrainingDefinitionsAdd from './TrainerAdd';

export default function Index() {
  return (
    <>
      <TrainingDefinitionsAdd />
      <TrainingDefinitionsList />
    </>
  );
}
